import React from 'react';
import Container from "../../../components/Container";
import PurchaseOptions from "./PurchaseOptions";

interface Props {

}

const BuyMoreBags = ({}: Props) => {
    return (
        <Container>
            <p className={'subheading'} style={{ marginBottom: 0, paddingBottom: '0.25em', marginTop: '1.5em' }}>Buy More Bags</p>
            <p style={{ marginTop: 0, paddingTop: 0, color: 'var(--colour-grey-text)' }}>
                Select the number of bags you would like to purchase and
                then click the buy button below the options to be taken to
                the payment. Bags purchased do not expire.
            </p>

            <PurchaseOptions />
        </Container>
    )
}

export default BuyMoreBags;